import React from 'react';
import { AvTooltip } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import { Box, Skeleton, SxProps } from '@mui/material';
import { WidgetHistoricLoadingAnimation } from './WidgetHistoricLoadingAnimation';
import { containerQueryMaxHeight, containerQueryMinHeight, WidgetHistoricLoadingContent } from './WidgetLoadingState.utils';

const DEFAULT_ANIMATION_SIZE = 54;
const SMALLER_ANIMATION_SIZE = 40;

function WidgetLoadingState({ isAsync, sx = {} }: { isAsync?: boolean; sx?: SxProps }) {
  return (
    <Box position="relative" width="100%" height="100%" sx={{ containerType: 'size', mb: 3.125, ...sx }}>
      <Skeleton
        width="100%"
        height="100%"
        animation="wave"
        variant="rectangular"
        sx={{ background: theme => theme.palette.colors.neutrals[300] }}
      />
      {isAsync ? (
        <Box
          position="absolute"
          sx={{
            ...flex.colCenter,
            inset: 0,
          }}>
          <AvTooltip
            muiProps={{
              PopperProps: {
                disablePortal: true,
                popperOptions: {
                  strategy: 'fixed',
                },
                sx: {
                  [containerQueryMinHeight]: {
                    display: 'none',
                  },
                },
              },
            }}
            title={<WidgetHistoricLoadingContent />}>
            <WidgetHistoricLoadingAnimation
              sx={{
                width: DEFAULT_ANIMATION_SIZE,
                height: DEFAULT_ANIMATION_SIZE,
                mb: 1.5,
                [containerQueryMaxHeight]: {
                  mb: 0,
                  width: SMALLER_ANIMATION_SIZE,
                  height: SMALLER_ANIMATION_SIZE,
                  cursor: 'pointer',
                },
              }}
            />
          </AvTooltip>
          <WidgetHistoricLoadingContent />
        </Box>
      ) : null}
    </Box>
  );
}

export default WidgetLoadingState;
